import type { SchemaField } from '@cli-types/core-engine/schema.js'
import { isEntitySlugField } from './is-entity-slug-field.js'
import { isGeneratedSchemaTitleField } from './is-generated-schema-title-field.js'

export function orderEntityIdentityFields(fields: SchemaField[]): SchemaField[] {
  const titleIndex = fields.findIndex(isGeneratedSchemaTitleField)
  const slugIndex = fields.findIndex(isEntitySlugField)

  if (titleIndex < 0 || slugIndex < 0 || (titleIndex === 0 && slugIndex === 1)) return fields

  const titleField = fields[titleIndex]!
  const slugField = fields[slugIndex]!

  return [
    titleField,
    slugField,
    ...fields.filter((_, index) => index !== titleIndex && index !== slugIndex)
  ]
}
